import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const MenaKurz = {
	name: NAME,
	apiProvider,
	router,
};
